/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Space_KeyInputs */

const en_rename_space_key = /** @type {(inputs: Rename_Space_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space key`)
};

const de_rename_space_key = /** @type {(inputs: Rename_Space_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereichsschlüssel`)
};

/**
* | output |
* | --- |
* | "Space key" |
*
* @param {Rename_Space_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_space_key = /** @type {((inputs?: Rename_Space_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Space_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_space_key(inputs)
	return en_rename_space_key(inputs)
});